import { Injectable } from '@angular/core';

@Injectable()
export class UtilService {
  private online: boolean = false;

  constructor() {

  }
  setOnline() {
    this.online = true;
  }
  setOffline() {
    this.online = false;
  }
  isOnline() {
    return this.online;
  }
  

}



// WEBPACK FOOTER //
// ./src/app/auth/util.service.ts